<sirius-container>
    @if (resolvedTitle() || resolvedTextHtml() || resolvedEyebrow()) {
        <sirius-card-collection-text
            [eyebrow]="resolvedEyebrow()"
            [title]="resolvedTitle()"
            [text]="resolvedTextHtml()"></sirius-card-collection-text>
    }
    <div class="sir-card-grid-list" data-cy="card-grid-list">
        @for (item of resolvedItems(); track item.link?.href ?? $index) {
            <div data-cy="card" class="sir-card-grid-item">
                <ng-template
                    siriusCardElement
                    [config]="item"
                    [imageData]="imageData()"
                    [cardSize]="resolvedCardSize()"
                    [dataSource]="dataSource()"
                    [containerType]="'grid'"
                    (selectEvent)="onCardSelect(item, $index)"></ng-template>
            </div>
        }
    </div>
</sirius-container>
